import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import moment from 'moment-timezone';
import Select from "react-select";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";
import TextField from "@material-ui/core/TextField";
import TicketAuditReviewLink from "utils/TicketAuditReviewLink";
import {Objects, Parts} from "../index";
import Collections from "./index";
import Search from '@material-ui/icons/Search'

export default class HelpDesksRandom extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state = {
			...this.state,
			search: "",
			regions: [],
			users: [],
			field_engineers: [],
			showFinancial: false,
			start_date: moment(Date.now()).format(),
			end_date: moment(Date.now()).format(),
			selectedUsers: [],
			selectedUser: null,
			selectedRegions: [],
			selectedRegion: null,
			amount: 5
		}
		moment.tz.setDefault("America/Phoenix");
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getRegions();
	}

	getHelpdesks = async () => {
		if (!this.state.selectedUser) {
			alert('You must select a FE first.')
			return;
		}
		this.setState({field_engineers: null})
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ);
		this.read = 'GET_RANDOM';
		model.filter = {
			'start_day': this.state.start_date,
			'end_day': this.state.end_date,
			'user': this.state.selectedUser.value,
			'amount': this.state.amount
		}
		model.search = this.state.search
		this.data = await model.submit(null, this.read);
		this.data = this.data ?? [];
		this.setState({
			field_engineers: this.data
		});
	}

	getRegions = async () => {
		let regionModel = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		regionModel.limit = 100;
		try {
			this.regions = await regionModel.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				//Todo maybe filter by ranking instead
				return a.name.localeCompare(b.name)
			});
			this.regions = this.regions.filter((item) => {
				return item.metro_walk_ranking !== null && item.metro_walk_ranking !== undefined
			})
			this.setState({
				regions: this.regions,
			});
		} catch (error) {
			console.log('error', error)
		}
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_FIELD_ENGINEERS';
		let usersPkeys = this.state.selectedUsers.map((user) => user.value);
		try {
			userModel.filter = {
				'filterRegions': this.state.selectedRegion ? [this.state.selectedRegion.value] : null,
				'bookableOnly': true,
			};
			this.users = await userModel.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];
			//let selected = this.users.filter(item => usersPkeys.includes(item.pkey));what was this for?

			this.setState({
				users: this.users
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleUsers = async (value) => {
		await this.setState({selectedUser: value, field_engineers: []})
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	toggleClose = () => {
		this.setState({calendarAlerts: null, toggleAlerts: false})
	}

	render() {
		const {loading} = this.state;

		const columns = [
			{
				Header: "Time",
				id: "time",
				accessor: obj => (obj.time)
			},
			{
				Header: "Client Name",
				id: "name",
				accessor: obj => (obj.customer_name),
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original.customer_pkey}`}>
								{props.original.customer_name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "FD Ticket #",
				id: "fresh_ticket",
				accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
				Cell: props => {
					return (
						<span>
							<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
						</span>
					);
				}
			},
			{
				Header: "Onsite",
				id: "on_site_time",
				accessor: obj => obj.on_site_time ? moment(obj.on_site_time).format('h:mm A') : ''
			},
			{
				Header: "Offsite",
				id: "off_site_time",
				accessor: obj => obj.off_site_time ? moment(obj.off_site_time).format('h:mm A') : ''
			},
			{
				Header: "Amount",
				id: "amount",
				accessor: obj => (obj.finance_amount),
				width: 100,
				className: "button-cell",
				Cell: props => {
					return (
						props.original.financial_pkey ?
							<Button
								color={'primary'}
								size={"sm"} block={true}
								onClick={() => {
									this.setState({
										financial: props.original.financial_pkey,
										ticket: props.original.Ticket,
									}, () => this.handleToggleModal('showFinancialModal'));
								}}
							>
								{props.original.finance_amount}
							</Button> : null
					);
				}
			},
			{
				Header: "Alerts",
				id: "alerts",
				width: 100,
				className: "button-cell",
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						props.original.alert_color ?
							<Button
								color={props.original.alert_color === 'red' ? 'danger' : 'caution'}
								size={"sm"} block={true}
								onClick={async () => {
									this.state.calendar = props.original.Pkey;
									this.handleToggleModal('help_desk_alerts_modal');
								}}
							>
								Show Alerts
							</Button> : null
					)
				}
			},
			{
				Header: "Review",
				id: "review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				accessor: obj => obj.pkey,
				Cell: props => <TicketAuditReviewLink row={props.original}/>
			},
			{
				Header: "Reviewed By",
				id: 'userChecked',
				accessor: obj => (obj.userChecked)
			},
			{
				Header: "Ticket",
				id: "ticket_review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Button color="blue-hoki" size={"sm"} block={true} onClick={() => {
							this.setState({ticket: props.original.Ticket}, () => {
								this.handleToggleModal('showTicketModal');
							});
						}}>
							<Search fontSize={'small'}/>
						</Button>
					);
				}
			}
		];

		const field_engineers = this.state.field_engineers ? this.state.field_engineers.length !== 0 ? this.state.field_engineers.map((engineer) => {
					return engineer.calendars?.length !== 0 ?
						(
							<div key={'engineer_card_' + engineer.pkey}>
								<Card>
									<CardHeader style={window.innerHeight >= 760 ? {marginBottom: '-35px'} : null} title={<div className={'row'}>
										<div className={'col-2'}>
											<div className={"form-group"}>
												<TextField
													fullWidth={true}
													size={"small"}
													label={"Field Engineer"}
													value={engineer.name_first + " " + engineer.name_last}
													variant="outlined"
													disabled={true}
												/>
											</div>
										</div>
										<div className={'col-2'}>
											<div className={"form-group"}>
												<TextField
													fullWidth={true}
													size={"small"}
													label={"Phone"}
													value={engineer.phone_cell && engineer.phone_cell.slice(0, 3) + "-" + engineer.phone_cell.slice(3, 6) + "-" + engineer.phone_cell.slice(6, engineer.phone_cell.length)}
													variant="outlined"
													disabled={true}
												/>
											</div>
										</div>
									</div>}/>

									<CardContent>
										<ReactTable
											key={engineer.calendars}
											columns={columns}
											manual // Forces table not to paginate or sort automatically, so we can handle it server-side
											data={engineer.calendars}
											loadingText="Requesting Data"
											expanderDefaults={{
												sortable: false,
												resizable: true,
												filterable: false,
												width: undefined
											}}
											className="-striped -highlight"
											defaultPageSize={engineer.calendars.length}
											showPagination={false}
											getTdProps={() => {
												return {
													style: {
														height: '35px'
													}
												}
											}}
											getTrProps={(header, rowInfo) => {
												return {
													style: {
														background: null
													}
												};
											}}
										/>
									</CardContent>
								</Card>
							</div>
						) : <div style={{alignContent: "center", fontSize: 25}} className={'form-group'}>
					No appointments scheduled for {engineer.name_first} {engineer.name_last} for the date range selected. Please select a different range or engineer.
				</div>;
				}) : [] : null;


		return (
			<div className={'box-body'}>
				<div className={"table-bar"}>
					<div className={"row"}>
						<div className={'col-4'} style={{zIndex: 100}}>
							<Parts.RegionSelectToggle
								parent={this}
								handleRegionsCallback={async () => {
									let selectedRegion = this.state.regions.filter(region => {
										return region.pkey === (this.state.filterRegion)
									})[0];
									await this.setState({
										selectedRegion: {value: selectedRegion.pkey, label: selectedRegion.name},
										selectedUser: null,
										field_engineers: []
									});
									await this.getUsers();
								}}
								multi={false}
								noCycle={false}
							/>
						</div>
						<div className={"col-3"} style={{zIndex: 100}}>
							<Select
								key={this.state.users}
								placeholder={"User Select"}
								isMulti={false}
								isClearable={false}
								value={this.state.selectedUser}
								onChange={this.handleUsers}
								options={this.state.users.map(user => {
									return (
										{value: user.pkey, label: user.name_first + " " + user.name_last})
								})}
							/>
						</div>
						<div className={'col-2'}>
							<TextField
								id="amount"
								label="Amount of Tickets"
								type="number"
								InputLabelProps={{
									shrink: true,
								}}
								value={this.state.amount}
								inputProps={{min: 0, max: 100}}
								onChange={(event) => {
									let value = event.target.valueAsNumber
									if (value < 0) {
										value = 0;
									} else if (value > 100) {
										value = 100
									}
									this.setState({amount: value})
								}}
								fullWidth={true}
							/>
						</div>
						<div className={'col-2'}>
							<Button onClick={async () => {
								await this.getHelpdesks()
							}}>
								Grab Random Tickets
							</Button>
						</div>
					</div>
					<div>
						<Modal
							isOpen={this.state.showStartDate}
							toggle={this.toggleClose}
							size={"sm"}
							backdrop={true}
							style={{display: "none"}}
						>
							<ModalBody>
								<Framework.Elements.Date
									label={"Custom Date"}
									value={this.state.start_date}
									update={(name, date) => {
										if (moment(date).isAfter(moment(this.state.end_date))) {
											alert('Start date may not be after the end date.')
											this.handleToggleModal('showStartDate');
											return;
										}
										this.state.start_date = moment(date).format();
										this.state.field_engineers = [];
										this.handleToggleModal('showStartDate');
									}}
									open={this.state.showStartDate}
									clearable={false}
									cancelLabel={''}
								/>
							</ModalBody>
						</Modal>
						<Modal
							isOpen={this.state.showEndDate}
							toggle={this.toggleClose}
							size={"sm"}
							backdrop={true}
							style={{display: "none"}}
						>
							<ModalBody>
								<Framework.Elements.Date
									label={"Custom Date"}
									value={this.state.end_date}
									update={(name, date) => {
										if (moment(date).isBefore(moment(this.state.start_date))) {
											alert('End date may not be before the start date.')
											this.handleToggleModal('showEndDate');
											return;
										}
										this.state.end_date = moment(date).format();
										this.state.field_engineers = [];
										this.handleToggleModal('showEndDate');
									}}
									open={this.state.showEndDate}
									clearable={false}
									cancelLabel={''}
								/>
							</ModalBody>
						</Modal>
						<div className={'row'}>
							<div className={'col-2'}>
								<div>
									Start Date &nbsp;&nbsp;
									<Button onClick={() => {
										this.handleToggleModal('showStartDate')
									}}>
										{moment(this.state.start_date).format('dddd MMM D')}
									</Button>
								</div>
							</div>
							<div className={'col-2'}>
								<div>
									End Date &nbsp;&nbsp;
									<Button onClick={() => {
										this.handleToggleModal('showEndDate')
									}}>
										{moment(this.state.end_date).format('dddd MMM D')}
									</Button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'row'}>
					<div className={'col-12'}>
						{field_engineers !== null ? field_engineers : <Framework.Elements.LoadingSpinner isLoading={true}/>}
					</div>
				</div>
				<Framework.Elements.UniversalModal
					id={this.state.engineer ?? null}
					name={"Help Desk Reschedule Fourth"}
					title={"Help Desk Reschedule Fourth"}
					object={Objects.HelpDeskRescheduleFourth}
					history={this.props.history}
					toggle={this.state.help_desk_reschedule_modal}
					reportClose={() => this.handleToggleModal('help_desk_reschedule_modal')}
					hideGoTo={true}
					hasSubmit={false}
				/>
				<Framework.Elements.UniversalModal
					size={"sm"}
					parent={this.state.calendar ?? null}
					title={"Help Desk Alerts"}
					object={Collections.HelpDeskAlerts}
					history={this.props.history}
					toggle={this.state.help_desk_alerts_modal}
					reportClose={() => this.handleToggleModal('help_desk_alerts_modal')}
					hideGoTo={true}
					hasSubmit={false}
				/>
				<Framework.Elements.UniversalModal
					size={"xl"}
					id={this.state.ticket}
					history={this.props.history}
					object={Objects.ScheduleTicket}
					submitLabel={"Update Ticket"}
					deleteLabel={"Delete Ticket"}
					locations={[""]}
					title={"Review Ticket"}
					toggle={this.state.showTicketModal}
					reportClose={() => this.handleToggleModal('showTicketModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
				/>
				<Framework.Elements.UniversalModal
					size={"md"}
					parent={this.state.ticket}
					id={this.state.financial}
					history={this.props.history}
					object={Objects.Financial}
					title={"Review Financial"}
					toggle={this.state.showFinancialModal}
					reportClose={() => this.handleToggleModal('showFinancialModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
					objectProps={{hideBack: true}}
				/>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
